<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Resume Penilaian
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <penilaianCalonPenanggungJawab
                :dataPJO="dataPJO"
                :isResume="isResume"
              />
              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    PENILAIAN ADMINISTRASI
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 7%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 73%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Bobot
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Skor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in dataPenilaianAdmin"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.aspek }}</td>
                          <td>
                            {{ item.bobot == null ? "N/A" : item.bobot + "%" }}
                          </td>
                          <td>
                            {{
                              item.skor == null ? "N/A" : item.skor.toFixed(2)
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            style="background: #ebecec; text-align: center"
                            colspan="2"
                          >
                            Total
                          </td>
                          <td style="background: #ebecec">
                            {{ totalBobot(dataPenilaianAdmin) }}
                          </td>
                          <td style="background: #ebecec">
                            {{ totalSkor(dataPenilaianAdmin) }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    PENILAIAN MATERI PRESENTASI
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 7%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 73%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Bobot
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Skor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in dataPenilaianMateri"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.aspek }}</td>
                          <td>
                            {{ item.skor == null ? "N/A" : item.bobot + "%" }}
                          </td>
                          <td>
                            {{
                              item.skor == null ? "N/A" : item.skor.toFixed(2)
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            style="background: #ebecec; text-align: center"
                            colspan="2"
                          >
                            Total
                          </td>
                          <td style="background: #ebecec">
                            {{ totalBobot(dataPenilaianMateri) }}
                          </td>
                          <td style="background: #ebecec">
                            {{ totalSkor(dataPenilaianMateri) }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    PENILAIAN KOMPETENSI TEKNIS CALON PJO
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 7%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 73%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Bobot
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Skor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in dataPenilaianKompetensi"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.aspek }}</td>
                          <td>
                            {{ item.skor == null ? "N/A" : item.bobot + "%" }}
                          </td>
                          <td>
                            {{
                              item.skor == null ? "N/A" : item.skor.toFixed(2)
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            style="background: #ebecec; text-align: center"
                            colspan="2"
                          >
                            Total
                          </td>
                          <td style="background: #ebecec">
                            {{ totalBobot(dataPenilaianKompetensi) }}
                          </td>
                          <td style="background: #ebecec">
                            {{ totalSkor(dataPenilaianKompetensi) }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    RESUME PENILAIAN
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 5%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 55%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 20%">
                            Bobot
                          </th>
                          <th style="background-color: #f8d7da; width: 20%">
                            Skor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in dataPenilaianResume"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.aspek }}</td>
                          <td>
                            {{ item.bobot == null ? "N/A" : item.bobot + "%" }}
                          </td>
                          <td>
                            {{
                              index == 0
                                ? skorAdmin
                                : index == 1
                                ? skorMateri
                                : index == 2
                                ? skorKompetensi
                                : "N/A"
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            style="background: #ebecec; text-align: center"
                            class="fs-5"
                            colspan="3"
                          >
                            Nilai Calon PJO
                          </td>
                          <td style="background: #ebecec" class="fs-5">
                            {{ skorResume.toFixed(2) }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-center">
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 2rem; color: #02a12d"
                              v-if="skorResume.toFixed(2) > 90"
                            />
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 1rem; color: #b2afaf"
                              v-else
                            />
                          </td>
                          <td colspan="2">
                            Lulus (dilanjutkan dengan pengesahan PJO oleh KTT)
                          </td>
                          <td class="text-center">&gt; 90</td>
                        </tr>
                        <tr>
                          <td class="text-center">
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 2rem; color: #02a12d"
                              v-if="
                                skorResume.toFixed(2) >= 65 &&
                                skorResume.toFixed(2) <= 90
                              "
                            />
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 1rem; color: #b2afaf"
                              v-else
                            />
                          </td>
                          <td colspan="2">
                            Perbaikan Minor (disubmit paling lambat 1 minggu)
                          </td>
                          <td class="text-center">65 ≤ Nilai ≤ 90</td>
                        </tr>
                        <tr>
                          <td class="text-center">
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 2rem; color: #02a12d"
                              v-if="skorResume.toFixed(2) < 65"
                            />
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 1rem; color: #b2afaf"
                              v-else
                            />
                          </td>
                          <td colspan="2">
                            Presentasi Ulang (paling lambat 2 minggu)
                          </td>
                          <td class="text-center">&lt; 65</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    LEMBAR PENGESAHAN
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 5%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 20%">
                            Nama
                          </th>
                          <th style="background-color: #f8d7da; width: 30%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 30%">
                            Departemen/Jabatan
                          </th>
                          <th style="background-color: #f8d7da; width: 15%">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(
                            dataPengesahan, dataKey, dataIndex
                          ) in lembarPengesahan"
                          :key="dataKey"
                        >
                          <tr
                            v-for="(item, index) in dataPengesahan"
                            :key="index"
                          >
                            <td>{{ index === 0 ? dataIndex + 1 : "" }}</td>
                            <td>{{ index === 0 ? item.namaKustodian : "" }}</td>
                            <td>
                              {{
                                item.aspek != null
                                  ? capitalized(item.aspek)
                                  : "-"
                              }}
                            </td>
                            <td>{{ item.department }} - {{ item.jabatan }}</td>
                            <td class="text-center">
                              <img
                                src="../../../assets/icons/check-64.png"
                                v-if="item.submitDate != null"
                                alt=""
                                style="width: 25%; height: auto"
                              />
                              <img
                                src="../../../assets/icons/close-64-old.png"
                                v-else
                                alt=""
                                style="width: 25%; height: auto"
                              />
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <!-- <tfoot>
                                                <tr>
                                                    <td style="background: #ebecec; text-align: center;" colspan="2">Total</td>
                                                    <td style="background: #ebecec;">{{ totalBobot(dataPenilaianKompetensi) }}</td>
                                                    <td style="background: #ebecec;">{{ totalSkor(dataPenilaianKompetensi) }}</td>
                                                </tr>
                                            </tfoot> -->
                    </table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 d-flex justify-content-end">
                  <button
                    type="submit"
                    class="btn btn_cari w-25"
                    @click="clickSubmit()"
                    v-if="userData.role.includes('ADMIN')"
                    :hidden="
                      statusSio == 5 ||
                      statusSio == 6 ||
                      statusSio == 7 ||
                      statusSio == 8 ||
                      statusSio == 3
                    "
                  >
                    Submit Resume Penilaian
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- &lt;!&ndash; You can customize the loading content here (e.g., a spinner) &ndash;&gt; -->
    <div>
      <img
        src="@/assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "@/GlobalDataMixin";
import penilaianCalonPenanggungJawab from "@/pages/sio/penilaian/penilaianCalonPenanggungJawab.vue";
// import SidebarComponent from '@/components/SideBar.vue';
// import Datepicker from "vuejs3-datepicker"
import axios from "axios";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  CMS_GET_PENILAIAN_RESUME,
  CMS_GET_PENILAIANDETAIL,
  CMS_GET_PENILAIAN_RESUME_SUBMIT,
} from "@/constants";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
const url_get_resume = API_BASE_URL + CMS_GET_PENILAIAN_RESUME;
const url_set_resume_submit = API_BASE_URL + CMS_GET_PENILAIAN_RESUME_SUBMIT;
const url_get_penilaiandetail = API_BASE_URL + CMS_GET_PENILAIANDETAIL;

export default {
  mixins: [GlobalDataMixin],
  name: "resumePenilaian",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
    // FontAwesomeIcon,
    penilaianCalonPenanggungJawab,
    // Datepicker
  },
  props: {},
  data() {
    return {
      isResume: true,
      isLoading: true,
      statusSio: null,
      dataPJO: {
        nama: null,
        perusahaan: null,
        tanggalPresentasi: null,
      },
      idPenjadwalan: null,
      dataPenilaianAdmin: null,
      dataPenilaianKompetensi: null,
      dataPenilaianMateri: null,
      skorAdmin: 0,
      skorKompetensi: 0,
      skorMateri: 0,
      bobotAdmin: 0,
      bobotKompetensi: 0,
      bobotMateri: 0,
      skorResume: 0,
      dataPenilaianResume: [
        {
          aspek: "Penilaian Administratif",
          bobot: 40,
        },
        {
          aspek: "Penilaian Materi Presentasi",
          bobot: 30,
        },
        {
          aspek: "Penilaian Kompetensi Teknis Calon PJO",
          bobot: 30,
        },
      ],
      lembarPengesahan: null,
    };
  },
  mounted() {
    this.idPenjadwalan = this.$route.params.idpenjadwalan;
    this.getResume();
    this.getPenilaianDetail();
    // Mendapatkan path URL saat ini
    // const currentPath = this.$router.currentRoute.value.path;

    // Mendapatkan parameter-parameter dari URL saat ini
    // const currentParams = this.$router.currentRoute.value.params;

    // console.log('Current Path:', currentPath);
    // console.log('Current Params:', currentParams);
  },
  computed: {},
  methods: {
    capitalized(name) {
      const capitalizedFirst = name[0].toUpperCase();
      const rest = name.slice(1);

      return capitalizedFirst + rest;
    },
    totalBobot(arr) {
      let totbobot = 0;
      if (arr != null) {
        for (let x = 0; x < arr.length; x++) {
          if (arr[x].skor != null) totbobot += arr[x].bobot;
        }
      }

      return totbobot + "%";
    },
    totalSkor(arr) {
      let totskor = 0;
      let totbobot = 0;
      if (arr != null) {
        for (let x = 0; x < arr.length; x++) {
          if (arr[x].skor != null) {
            totskor += (arr[x].skor * arr[x].bobot) / 100;
            totbobot += arr[x].bobot;
          }
        }
      }
      totskor = (totskor / totbobot) * 100;
      return isNaN(totskor.toFixed(2)) ? 0 : totskor.toFixed(2);
    },
    getResume() {
      let bodyJson = {
        idPenjadwalan: this.idPenjadwalan,
      };
      axios
        .post(url_get_resume, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response getResume : ", response);
          if (response != null) {
            let dta = response.data;
            this.dataPenilaianAdmin = dta.administrasi;
            this.dataPenilaianKompetensi = dta.kompetensi;
            this.dataPenilaianMateri = dta.presentasi;
            this.skorAdmin = this.totalSkor(this.dataPenilaianAdmin);
            this.skorKompetensi = this.totalSkor(this.dataPenilaianKompetensi);
            this.skorMateri = this.totalSkor(this.dataPenilaianMateri);
            this.bobotAdmin = this.totalBobot(this.dataPenilaianAdmin);
            this.bobotKompetensi = this.totalBobot(
              this.dataPenilaianKompetensi
            );
            this.bobotMateri = this.totalBobot(this.dataPenilaianMateri);

            this.skorResume =
              this.skorAdmin * (this.dataPenilaianResume[0].bobot / 100) +
              this.skorMateri * (this.dataPenilaianResume[1].bobot / 100) +
              this.skorKompetensi * (this.dataPenilaianResume[2].bobot / 100);
            this.lembarPengesahan = this.groupDataByKustodian(dta.kustodian);
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log("error getResume : ", error);
          alert("error getResume");
          this.isLoading = false;
        });
    },
    getPenilaianDetail() {
      let bodyJson = {
        idPenjadwalan: this.idPenjadwalan,
        jenis: "administrasi",
      };

      axios
        .post(url_get_penilaiandetail, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response getPenilaianDetail : ", response);
          if (response.data !== undefined && response.data !== null) {
            let dt = response.data;
            // let dtpenilaian = dt.dataPenilaian;
            // if(jenis=='administrasi'){
            // this.dataPenilaianKustodian = dt.kustodians;
            this.dataPJO.nama = dt.pjo;
            this.dataPJO.perusahaan = dt.perusahaan;
            this.dataPJO.tanggalPresentasi = dt.schedule;
            this.statusSio = dt.statusSio;
            //     this.idPenilaianAdmin = dtpenilaian[0].id;
            //     let pn = JSON.parse(dtpenilaian[0].penilaian);
            //     if(JSON.parse(dtpenilaian[0].penilaian).penilaian!==undefined){
            //         pn = JSON.parse(dtpenilaian[0].penilaian).penilaian
            //     }
            //     this.dataPenilaianAdmin = pn;
            //     console.log('this.dataPenilaianAdmin:',this.dataPenilaianAdmin);
            // }else if(jenis=='kompetensi'){
            //     this.dataPenilaianKompetensi = JSON.parse(dtpenilaian[0].penilaian).penilaian;
            //     console.log('this.dataPenilaianKompetensi:',this.dataPenilaianKompetensi);
            // }else if(jenis=='presentasi'){
            //     this.dataPenilaianMateri = JSON.parse(dtpenilaian[0].penilaian).penilaian;
            //     console.log('this.dataPenilaianMateri:',this.dataPenilaianMateri);
            // }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error getPenilaianDetail : ", error);
          alert("error getPenilaianDetail : ", error);
        })
        .then(() => {});
    },
    clickSubmit() {
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah Anda yakin akan simpan data ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1db61d",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Simpan",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitResume();
        }
      });
    },
    submitResume() {
      let bodyJson = {
        idPenjadwalan: this.idPenjadwalan,
        skorResume: this.skorResume,
        kttApproval: true,
      };
      axios
        .post(url_set_resume_submit, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response getResume : ", response);
          // console.log("data : ", response.data)
          if (response != null) {
            this.alertSuksesSubmitResume();
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log("error getResume : ", error);
          alert("error getResume");
          this.isLoading = false;
        });
    },
    alertSuksesSubmitResume() {
      Swal.fire({
        title: "Resume Penilaian",
        text: "Submit sukses!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$router.back()
        this.$router.push("/approval-sio");
      });
    },
    groupDataByKustodian(data) {
      return data.reduce((groups, item) => {
        const key = item.namaKustodian;
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(item);
        return groups;
      }, {});
    },
  },
};
</script>

<style></style>
